import React from 'react';
import { useHistory } from 'react-router-dom';
import {
  Link as ChakraLink,
  LinkProps as ChakraLinkProps,
} from '@chakra-ui/react';

import { findInHistory } from '../../support/history';

import { resolve } from './helpers';
import { Destination } from './types';

export type LinkProps = Omit<ChakraLinkProps, 'href'>;

type RouteProps<T extends string> = {
  back?: boolean;
  to: Destination<T>;
};

export function createLink<RoutePath extends string>() {
  const Link = <T extends RoutePath>(props: LinkProps & RouteProps<T>) => {
    let history = useHistory();
    let { back, to, onClick, ...otherProps } = props;
    let path = to[0];
    let params = to[1] || {};
    let resolvedPath = resolve(path, params);
    return (
      <ChakraLink
        {...otherProps}
        href={resolvedPath}
        onClick={(event) => {
          onClick?.(event);
          event.preventDefault();
          if (back) {
            let found = findInHistory(resolvedPath);
            if (found) {
              history.go(found.delta);
              return;
            }
          }
          history.push(resolvedPath);
        }}
      />
    );
  };
  return Link;
}
